module.exports = __webpack_public_path__ + "img/close.6481c7f8.svg";